export const CONNECTOR_URL = `/assets/components/ecommerce/connector.php`;

export const RequestAction = {
  REMOVE_PRODUCT: `remove_product`,
  GET_LIST_DATA: `get_list_data`
};
